import StyledDropzone from './StyledDropzone';

export default StyledDropzone;
